import mergeObjects from '@bybeam/platform-lib/answers/mergeObjects';
import { ApplicationSection, FieldType, TextInputType } from '@bybeam/platform-types';
import { SpecialSectionKeys } from '../standards/types.js';
import { makeEduConfig } from './baseConfig.js';

const CONFIG = makeEduConfig();

const reviewSectionIdx = CONFIG.sections.findIndex(({ key }) => key === SpecialSectionKeys.Review);
CONFIG.sections[reviewSectionIdx] = mergeObjects(
  [
    CONFIG.sections[reviewSectionIdx],
    // remove the Application Assistance question
    { questionGroups: [null] } as ApplicationSection,
  ],
  'merge',
);

// Remove bank account question
const yourSituationSections = CONFIG.sections.find(({ key }) => key === 'youAndYourSituation');
const yourSituationQuestionGroup = yourSituationSections.questionGroups.find(
  ({ key }) => key === 'youAndYourSituation',
);
yourSituationQuestionGroup.questions = yourSituationQuestionGroup.questions.filter(
  (question) => question.key !== 'hasBankAccount',
);

// Update other information
yourSituationQuestionGroup.questions[
  yourSituationQuestionGroup.questions.findIndex(({ key }) => key === 'otherInformation')
] = {
  key: 'otherInformation',
  copy: {
    title: 'Additional Information',
    intro:
      'Please use this space to share additional information about the emergency you are experiencing.',
  },
  fields: [
    {
      type: FieldType.Text,
      inputType: TextInputType.Text,
      key: 'otherInformation',
      copy: 'Comments',
      props: { multiline: true, rows: 5 },
      validation: { required: true },
    },
  ],
};

export default CONFIG;
